/* src/app/tools-components/cell-manual-edit/cell-manual-edit.component.scss */
.cell-editable {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  display: flex;
  align-items: center;
}
.cell-editable:hover {
  cursor: pointer;
  background-color: rgba(114, 114, 127, 0.08);
}
.cell-editable:hover .show {
  opacity: 1;
}
.cell-edited {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  display: flex;
  align-items: center;
  background-color: rgba(255, 230, 0, 0.7);
}
.cell-edited:hover {
  cursor: pointer;
  background-color: rgba(114, 114, 127, 0.28);
}
.cell-edited:hover .show {
  opacity: 1;
}
.show {
  opacity: 0;
  color: #155cb4;
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 400;
  margin-left: 0.3125rem;
}
/*# sourceMappingURL=cell-manual-edit.component.css.map */
